import { Button, ButtonProps } from '@chakra-ui/react';
import IconPencil from 'assets/icons/icon-pencil.svg?react';
import { Link, LinkProps } from 'react-router-dom';

type ButtonEditProps = ButtonProps & LinkProps;

export default function ButtonEdit(props: ButtonEditProps) {
  return (
    <Button
      size="sm"
      rightIcon={<IconPencil />}
      as={Link}
      {...props}
    >
      Editar
    </Button>
  )
}
